import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'automations',
    viewPath: props.viewPath,
  })

  let automation_id = useDataValue({
    context: 'automation',
    path: 'automation_id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'create_automations', automation_id })
  }
}
